export default "__VITE_ASSET__9915f185__"